import React, { useEffect } from "react";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import AlertDialog from "../pages/account/admin/components/Dialog";

const ProtectedAdminRoute: React.FC = () => {
  const [alertOpen, setAlertOpen] = React.useState(false);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAdmin = ["admin", "manager"].includes(user?.group?.title ?? "");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      setAlertOpen(true);
    }
  }, [isAdmin]);

  const handleAlertClose = () => {
    setAlertOpen(false);
    navigate("/");
  };

  if (!isAdmin) {
    return (
      <AlertDialog
        open={alertOpen}
        onClose={handleAlertClose}
        title="Access Denied"
        message="Dear user, you do not have the required permissions to access this page. Please contact your service administrator."
      />
    );
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
